import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Button, palette, color } from "@conserveit/blocks";
import Menu from "../Menu";
import IssueProps from "./components/IssueProps";
import Preview from "./components/IssuePreview";

const $Container = styled.div`
  position: relative;
  display: inline-block;
`;

const Trigger = styled(Button)`
  height: 22px;
  line-height: 18px;
  padding: 0 8px;
  transition: none;
  background: ${palette.neutral8};

  &:active,
  &:focus {
    color: ${color.pureWhite};
    text-decoration: none;
    background: ${palette.neutral7};
  }
`;

class PreviewIssue extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
  };

  handleOpenPreview = (id, fetch, data) => (isOpen) => {
    if (data === undefined && isOpen) {
      fetch(id);
    }
  };

  render() {
    const { id, children } = this.props;
    return (
      <IssueProps issueId={id}>
        {({ data, getPreview }) => (
          <Menu onToggle={this.handleOpenPreview(id, getPreview, data)}>
            {({ isOpen, toggle, menuRef }) => (
              <$Container ref={menuRef}>
                <Preview isOpen={isOpen} data={data} />
                <Trigger thin type="button" onClick={toggle}>
                  {children}
                </Trigger>
              </$Container>
            )}
          </Menu>
        )}
      </IssueProps>
    );
  }
}

export default PreviewIssue;
